import { useIsHelpChatEnabled, useLogIntercomEvent } from '@hcs/help-chat';
import { EngagementEventPayload, IntercomEventData } from '@hcs/types';

import { isMeaningfulEvent } from '../utils';

export const useTrackIntercomEvent = () => {
  const helpChatEnabled = useIsHelpChatEnabled();
  const logIntercomEvent = useLogIntercomEvent();
  const trackIntercomEvent = (engagementEvent: EngagementEventPayload) => {
    // only track meaningful events
    if (
      helpChatEnabled &&
      isMeaningfulEvent(engagementEvent) &&
      engagementEvent.eventData
    ) {
      const {
        device,
        eventSection,
        dataHcName,
        originalEventType,
        property_report,
        requestedProduct,
        offer_now,
      } = engagementEvent.eventData;

      // note that intercom limits this data to 20 attributes
      const intercomEventData: IntercomEventData = {
        browser: device?.browser,
        browserVersion: device?.browserVersion,
        os: device?.os,
        osVersion: device?.osVersion,
        eventSection,
        eventType: engagementEvent.eventType,
        originalEventType,
        app: engagementEvent.app,
        pageGroup: engagementEvent.pageGroup,
        httpPath: engagementEvent.httpPath,
        httpReferrer: engagementEvent.httpReferrer,
        dataHcName,
        propertyReportAddressId: property_report?.hcAddressId,
        propertyReportAddressSlug: property_report?.slug,
        propertyReportId: property_report?.reportId,
        offerNowAddressId: offer_now?.hcAddressId,
        offerNowAddressSlug: offer_now?.slug,
        requestedProduct: requestedProduct,
      };

      logIntercomEvent(engagementEvent.eventName, intercomEventData);
    }
  };
  return {
    mutate: trackIntercomEvent,
  };
};
